<template>
    <div :class="statusClass">
        {{ $t(`components.reservations.reservation_status.statuses.${offerStatus}`) }}
    </div>
</template>

<script>
    import ReservationStatusEnum from 'enums/reservation_status.enum'

    export default {
        props: {
            status: { type: String, required: true },
            size: { type: String, default: 'medium' },
        },

        computed: {
            offerStatus() {
                return ReservationStatusEnum[this.status]
            },

            statusClass() {
                return {
                    'reservation-status': true,
                    [`reservation-status__color--${this.offerStatus}`]: true,
                    [`reservation-status__size--${this.size}`]: true,
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/components/reservations/_reservation-status.scss';
</style>
